import DaoUser from "../modules/dao/user";
import {msgKO} from "./msg/ko";
import {msgEn} from "./msg/en";
import {osname} from "../modules/func";
import {DBHelperClass} from "../modules/db";

export const isDev = process.env.NODE_ENV !== "production";

/**
 * 파임덕정보
 * @type {{
    name: string,
    lang: string,
    app: string,
    version_number: int,
    version: string,
    linebreak: RegExp,
    avatar_empty: string,
    channel_new: number,
    notice_new: number,
    recent_limit: number,
    history_limit: number,
    user: DaoUser
    main: DaoMain | null,
    category: {
        business: DaoCategory[],
        theme: DaoCategory[],
        tempo: DaoCategory[],
        genre: DaoCategory[],
        ment: {}
    }
 }}
 */
export const rd = {
    name: '라임덕',
    lang: 'ko',
    app: 'RHYMEDUCK',
    version_number: 1,
    version: '1.0.0',
    os: osname(),
    linebreak: /\[\\n]/gmi,
    avatar_empty: '/images/main-img.png',
    channel_new: 15,    // days
    notice_new: 7,      // days
    history_limit: 10,  // ea
    playlist_limit: 20,  // ea
    ment_limit: 50,  // ea
    user: new DaoUser(),
    main: null,
    category: {
        business: [],
        theme: [],
        tempo: [],
        genre: [],
        ment: {},
    }
};

/**
 * @type {DBHelperClass}
 */
export const DBHelpers = new DBHelperClass();

export function msg() {
    switch (rd.lang) {
        case 'en':
            return msgEn;
        default:
            return msgKO;
    }
}

export const db_tables = {
    users: 'users',
    settings: 'settings',
    history: 'history'
};

/**
 *
 * @type {{name: string, version: number, objectStoresMeta: [{store: string, storeConfig: {keyPath: string, autoIncrement: boolean}, storeSchema: [{name: string, keyPath: string, options: {unique: boolean}},{name: string, keyPath: string, options: {unique: boolean}},{name: string, keyPath: string, options: {unique: boolean}},{name: string, keyPath: string, options: {unique: boolean}},{name: string, keyPath: string, options: {unique: boolean}}]},{store: string, storeConfig: {keyPath: string, autoIncrement: boolean}, storeSchema: [{name: string, keyPath: string, options: {unique: boolean}},{name: string, keyPath: string, options: {unique: boolean}},{name: string, keyPath: string, options: {unique: boolean}},{name: string, keyPath: string, options: {unique: boolean}}]}]}}
 */
export const db_config = {
    name: rd.app,
    version: 8,
    objectStoresMeta: [
        {
            store: db_tables.users,
            storeConfig: { keyPath: "id", autoIncrement: true },
            storeSchema: [
                { name: "shopid", keyPath: "shopid", options: { unique: false } },
                { name: "bizid", keyPath: "bizid", options: { unique: false } },
                { name: "groupid", keyPath: "groupid", options: { unique: false } },
                { name: "serviceid", keyPath: "serviceid", options: { unique: false } },
                { name: "mac", keyPath: "mac", options: { unique: false } },
                { name: "use_mobile", keyPath: "use_mobile", options: { unique: false } },
            ],
        },
        {
            store: db_tables.history,
            storeConfig: { keyPath: "id", autoIncrement: true },
            storeSchema: [
                { name: "date", keyPath: "date", options: { unique: false } },
                { name: "at", keyPath: "at", options: { unique: false } },
                { name: "serviceid", keyPath: "serviceid", options: { unique: false } },
                { name: "groupid", keyPath: "groupid", options: { unique: false } },
                { name: "type", keyPath: "type", options: { unique: false } },
                { name: "songid", keyPath: "songid", options: { unique: false } },
                { name: "songname", keyPath: "songname", options: { unique: false } },
                { name: "artistname", keyPath: "artistname", options: { unique: false } },
                { name: "albumname", keyPath: "albumname", options: { unique: false } },
                { name: "title_yn", keyPath: "title_yn", options: { unique: false } },
                { name: "bset_yn", keyPath: "bset_yn", options: { unique: false } },
                { name: "mp3name", keyPath: "mp3name", options: { unique: false } },
                { name: "playtime", keyPath: "playtime", options: { unique: false } },
                { name: "favorite", keyPath: "favorite", options: { unique: false } },
                { name: "image", keyPath: "image", options: { unique: false } },
            ],
        },
    ],
};

export const apis = {
    host:                   '//napi.rhymeduck.com',
    host_dev:               '//dev.napi.rhymeduck.com',
    login:                  '/player/login.json?id=:id&pw=:pw&mac=:mac&auth_code=:auth_code',
    ping_pong:              '/player/pp.json?id=:id&mac=:mac',
    volume:                 '/player/volume.setting.json?serviceid=A0104379&master=0.13&bgm=1&cm=1&effect1=1&effect2=1&effect3=1&soundid=1&alertcm=1&mute_master=false&mute_bgm=false&mute_effect1=false&mute_effect2=false&mute_effect3=false&mute_soundid=false&mute_alertcm=false&userstop=N&tm=1736840534799&cpmode=SHOPCAST',
    common:                 '/ui/common.json?serviceid=:serviceid&groupid=:groupid',
    magazine:               '/ui/magazine.json?serviceid=:serviceid&groupid=:groupid',
    category:               '/ui/channel.category.json?serviceid=:serviceid&groupid=:groupid',
    business_setting:       '/ui/business.setting.json?serviceid=:serviceid&groupid=:groupid&business=:business',

    channel_lists:          '/ui/channel.lists.json?serviceid=:serviceid&groupid=:groupid&category=:category&p=:p',
    channel_search:         '/ui/channel.search.json?serviceid=:serviceid&groupid=:groupid&search_key=:search_key&search_val=:search_val&p=:p',
    channel_favorite_list:  '/ui/channel.favorite.list.json?serviceid=:serviceid&groupid=:groupid',
    channel_favorite:       '/ui/channel.favorite.json?serviceid=:serviceid&groupid=:groupid&chid=:chid',
    channel_info:           '/ui/channel.info.json?serviceid=:serviceid&groupid=:groupid&chid=:chid',
    channel_change:         '/player/channel.setting.json?serviceid=:serviceid&groupid=:groupid&chid=:chid',

    media_info:             '/ui/song.info.json?serviceid=:serviceid&groupid=:groupid&songid=:songid',
    media_favorite:         '/ui/song.favorite.json?serviceid=:serviceid&groupid=:groupid&songid=:songid',

    ment:                   '/ui/ment.json?serviceid=:serviceid&groupid=:groupid',
    ment_search:            '/ui/cm.search.json?serviceid=:serviceid&groupid=:groupid&search_key=:search_key&search_val=:search_val&p=:p',
    ment_socket:            '/ui/socket.json?serviceid=:serviceid&groupid=:groupid&cid=:cid&type=:type&code=:code',

    song_favorite:          '/ui/song.favorite.json?serviceid=:serviceid&groupid=:groupid&songid=:songid',
};

export const websites = {
    host: 'https://nweb.rhymeduck.com',
    host_dev:   'https://dev.nweb.rhymeduck.com',
    destination:    '/gate?:query'
};

export const routes = {
    splash                      : '/',

    login                       : '/login',
    login_process               : '/login.process',
    login_process_pw            : '/login.process?id=:id&pw=:pw',
    login_process_magazine      : '/login.process?id=:id&mac=:mac&app=:app&serviceid=:serviceid&groupid=:groupid&cpmode=:cpmode&ver_player=:ver_player&ver_page=:ver_page&ver_web=:ver_web&ver_os=:ver_os',
    logout                      : '/logout',
    business                    : '/business',

    main                        : '/main',
    channel                     : '/main/channel',
    broadcast                   : '/main/broadcast',
    search_channel              : '/main/type_search/channel',
    search_ment                 : '/main/type_search/ment',
    search_business             : '/main/type_search/business/:id',
    search_theme                : '/main/type_search/theme/:id',
    search_genre                : '/main/type_search/genre/:id',
    search_result_channel       : '/main/type_search/channel/result/:query',
    search_result_ment          : '/main/type_search/ment/result/:query',
    mypage                      : '/main/mypage',
    mychannel                   : '/main/mypage/channel',
    myschedule                  : '/main/mypage/schedule',
    setting                     : '/main/setting',
    cscenter                    : '/main/cscenter',
    event_logs                  : '/main/event.logs',
    notice                      : '/main/notice/:id',

    not_found                   : '/*',
    not_found_main              : '/main/*',
};

// 검색 선택상자 데이터
export const type_search = {
    channel: '채널',
    ment: '안내멘트',
};

// 검색 선택상자 데이터
export const type_favorite = {
    channel: 'channel',
    media: 'media',
    ment: 'ment',
};

// 팝업 종류
export const type_popup = {
    theme_filter: 'theme.filter',
    channel: 'channel',
    ment: 'ment',
    history: 'history',
    business: 'business'
};

// 모달 종류
export const type_modal = {
    alert: 'dialog_alert',
    confirm: 'dialog_confirm',
    warn: 'dialog_warn',
};

// 모달 아이콘 종류
export const type_modal_icon = {
    none: 'none',
    error: 'error',
    check: 'check',
    warn: 'warn',
};

// 채널 종류
export const type_channel = {
    default: 'channel_default',
    recommand: 'channel_recommand',
    recent: 'channel_recent',
    chart: 'channel_chart',
    chart_biz: 'channel_chart_biz',
    pd_pick: 'channel_pd_pick',
    detail: 'channel_detail',
    player: 'channel_player',
};

// 안내멘트 종류
export const type_ment = {
    default: 'ment_default',
    today: 'ment_today',
    popup: 'ment_popup',
};

export const type_media = {
    cmt: 'cmt',
    ucmt: 'ucmt',
    mcmt: 'mcmt',
    live: 'live',
    cme: 'cme',
    ad: 'ad',
    alert: 'alert',
    effect1: 'effect1',
    effect2: 'effect2',
    effect3: 'effect3',
    bgm: 'bgm',
};

/**
 * 로그인 여부
 * @returns {boolean}
 */
export function isLogin() {
    return rd.user && rd.user.isValid;
}

/**
 * api 주소
 * @param url
 * @param params
 * @returns {*}
 */
export function api(url, params={}) {
    return (!isDev ? apis.host : apis.host_dev) + url.replace(/:([a-zA-Z0-9_]+)/g, (match, paramName) => {
        if (params.hasOwnProperty(paramName)) {
            return params[paramName];
        }
    })
}

/**
 * website 주소
 * @param url
 * @param params
 * @returns {*}
 */
export function website(url, params={}) {
    return (!isDev ? websites.host : websites.host_dev) + url.replace(/:([a-zA-Z0-9_]+)/g, (match, paramName) => {
        if (params.hasOwnProperty(paramName)) {
            return params[paramName];
        }
    })
}

export function cancelController() {
    const controller = {
        signal: {
            aborted: false,
            _listeners: []
        },
        abort() {
            if (!controller.signal.aborted) {
                controller.signal.aborted = true;
                controller.signal._listeners.forEach(listener => {
                    try {
                        listener.call(null);
                    } catch (e) {
                        console.error("Abort listener error:", e);
                    }
                });
                controller.signal._listeners = [];
            }
        }
    };

    controller.signal.addEventListener = function (type, listener) {
        if (type === 'abort' && typeof listener === 'function') {
            controller.signal._listeners.push(listener);
        }
    };

    controller.signal.removeEventListener = function (type, listener) {
        if (type === 'abort' && typeof listener === 'function') {
            const index = controller.signal._listeners.indexOf(listener);
            if (index !== -1) {
                controller.signal._listeners.splice(index, 1);
            }
        }
    };

    return controller;
}

/**
 * 데이터 전송
 * @param url
 * @param options
 * @returns {Promise<any>}
 */
export async function send(url, options = {}) {
    if(isDev) {
        options.method = 'GET';
        delete options.body;
    }

    // if(!options.hasOwnProperty("responseType")) options.responseType = 'json';
    if(!options.hasOwnProperty("timeout")) options.timeout = 5000;

    let controller = options.controller;

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        // 응답 타입 설정 (예: 'json', 'text', 'blob', etc.)
        if (options.responseType) {
            xhr.responseType = options.responseType;
        }

        xhr.open(options.method || 'GET', url, true);

        // 헤더 설정
        if (options.headers) {
            for (let key in options.headers) {
                xhr.setRequestHeader(key, options.headers[key]);
            }
        }

        // 타임아웃 설정
        if (options.timeout) {
            xhr.timeout = options.timeout;
        }

        // 안전하게 abort 처리
        if (
            controller &&
            controller.signal &&
            typeof controller.signal.addEventListener === 'function'
        ) {
            controller.signal.addEventListener('abort', () => {
                xhr.abort();
            });
        }

        xhr.onload = function () {
            cleanup();
            const response = {
                ok: xhr.status >= 200 && xhr.status < 300,
                status: xhr.status,
                statusText: xhr.statusText,
                url: xhr.responseURL,
                response: xhr.response,
                text: () => Promise.resolve(xhr.responseText),
                json: () => {
                    try {
                        return Promise.resolve(JSON.parse(xhr.responseText));
                    } catch (e) {
                        return Promise.reject(new Error('Invalid JSON'));
                    }
                }
            };
            resolve(response.json());
        };

        xhr.onerror = function () {
            cleanup();
            reject(new Error('Network error'));
        };

        xhr.ontimeout = function () {
            cleanup();
            reject(new Error('Request timeout'));
        };

        xhr.onabort = function () {
            cleanup();
            reject(new Error('Request aborted'));
        };

        function cleanup() {
            xhr.onload = null;
            xhr.onerror = null;
            xhr.ontimeout = null;
            xhr.onabort = null;
            if (controller && controller.signal) {
                controller.signal._listeners = [];
            }
            controller = null;
        }

        xhr.send(options.body || null);
    });
}

export async function sendGet(url) {
    const options = {
        method: "GET",
        cache: "no-cache",
        credentials: "same-origin",
        redirect: "follow",
        referrerPolicy: "no-referrer"
    };
    return await send(url, options);
}

export async function sendPost(url, params = {}) {
    const forms = new FormData();
    if(params) {
        Object.keys(params).forEach(key => {
            forms.append(key, params[key]);
        })
    }
    const options = {
        method: "POST",
        cache: "no-cache",
        credentials: "same-origin",
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: forms
    };
    return await send(url, options);
}

export async function sendPayload(url, params = {}) {
    const options = {
        method: "POST",
        cache: "no-cache",
        credentials: "same-origin",
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify(params)
    };
    return await send(url, options);
}

/**
 * 라우트 경로
 * route(/main/type_search/result/:source/:query, source_value, query_value) -> /main/type_search/result/source_value/query_value 형태로 변경됨
 * @param url
 * @param args
 */
export function route(url, ...args) {
    try {
        if(args.length !== 0) {
            let urls = url.split('/');
            let urlOffsets = 0;
            if(urls.length > 0) {
                for(let i = 0; i < urls.length; i++) {
                    const urlValue = urls[i];
                    if(urlValue.match(/^:.+/gi)) {
                        urls[i] = args[urlOffsets];
                        urlOffsets++;
                    }
                }
            }
            url = urls.join('/');
        }
    } finally {
        window.location.hash = url;
    }
}

export function throws(message) {
    throw new Error(message);
}

export function errors(e) {
    console.error(e);
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/vars/rd.js